import { FormInstance } from 'antd';
import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { useChangeUserDebtDetails } from '../utils/hooks/useChangeUserDebtDetails';

interface ChangeUserDebtDetailsProps {
  userId: string | undefined;
  action: ReactElement;
  formInstance: FormInstance;
  onSuccess?: () => void;
}

export const ChangeUserDebtDetails: FC<ChangeUserDebtDetailsProps> = memo((props) => {
  const { userId, action, formInstance, onSuccess } = props;

  const { t } = useAppTranslation('profile');

  const updatedData = formInstance.getFieldsValue();

  const { handleChangeUserDetails, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useChangeUserDebtDetails({
    userId,
    updatedData,
    onSuccess,
  });

  const handleClick = useCallback(async (): Promise<void> => {
    try {
      await formInstance.validateFields();
      openConfirmModal();
    } catch (e) {
      console.log(e);
    }
  }, [formInstance, openConfirmModal]);

  return (
    <>
      {React.cloneElement(action, { onClick: handleClick })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Change debt details')}
        description={t('Are you sure you want to change debt details?')}
        isLoading={isLoading}
        onOk={handleChangeUserDetails}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
